<template>
  <div>
    <div v-if="is_loading" class="is-flex is-align-items-center is-justify-content-center is-flex-direction-column">
      <div class="loading"></div>
      <p class="bold">טוען מידע חוץ...</p>
    </div>
    <div v-else>
      <div class="is-flex is-justify-content-flex-end is-align-items-center" style="gap: 10px;">
        <b>סטטוס</b>
        <select v-model="status" dir="rtl">
          <option>active</option>
          <option>expired</option>
        </select>
        <a @click="boost" class="button is-info" :class="{ 'is-loading': is_boosting }">BOOST</a>
      </div>
      <div>
        <p><b>כותרת משרה</b> (עד 60 תווים)</p>
        <input class="outlined full_width" v-model="title" maxlength="60">
        <p class="title_length" dir="ltr">{{title.length}} / 60</p>
      </div>
      <div v-if="title.length > 50">
        <p><b>כותרת לדרושים</b> (עד 50 תווים)</p>
        <input class="outlined full_width" v-model="drushim_title" maxlength="50">
        <p class="title_length" dir="ltr">{{drushim_title.length}} / 50</p>
      </div>
      <div>
        <p><b>תיאור התפקיד</b></p>
        <textarea class="full_width" v-model="description"></textarea>
      </div>
      <div>
        <p><b>דרישות התפקיד</b></p>
        <textarea class="full_width" v-model="requirements"></textarea>
      </div>
      <div class="is-flex is-justify-content-space-between">
        {{default_location}}
        <outsource-all-jobs-cities v-model="alljobs_picked_cities" :cities="alljobs_cities" :picked_cities="alljobs_picked_cities">
        </outsource-all-jobs-cities>
        <outsource-job-master-cities v-model="jobmaster_picked_cities" :picked_cities="jobmaster_picked_cities"></outsource-job-master-cities>
      </div>
      <div v-if="drushimActive">
        <OutsourceDrushimCities v-model="drushim_picked_cities" :picked_cities="drushim_picked_cities" />
      </div>
      <div v-if="drushimActive">
        <OutsourceDrushimAreas v-model="drushim_picked_areas" :picked_areas="drushim_picked_areas" :zones_and_regions="drushim_zones_and_regions" />
      </div>
      <div v-if="jobnetActive">
        <OutsourceJobnetAreas v-model="jobnet.areas" title="אזור (4)" :areas="jobnet.jobAreas" />
      </div>
      <div v-if="drushimActive">
        <p><b>שנות נסיון (3)</b></p>
        <select v-model="drushim_picked_seniority" dir="rtl">
          <option value=''>NOT SELECTED</option>
          <option v-for="seniority in drushim_init_data.seniorities" :value="seniority.id" :key="seniority.id">{{ seniority.text }}</option>
        </select>
      </div>
      <div>
        <p><b>שנות נסיון דרושות למשרה</b></p>
        <select v-model="jobmaster_required_experience_years" dir="rtl">
          <option value="">לא נבחר</option>
          <option value="ללא ניסיון">ללא ניסיון</option>
          <option value="1-2">1-2</option>
          <option value="3-4">3-4</option>
          <option value="5-6">5-6</option>
          <option value="7+">7+</option>
        </select>
      </div>
      <div>
        <div class="is-flex is-justify-content-space-between">
          <div>
            <p><b>היקף משרה</b></p>
            <div v-for="job_type in alljobs_job_types" :key="job_type.JobTypeID">
              <div>
                <Checkbox :checked="job_type.is_selected" v-model="job_type.is_selected">{{job_type.JobTypeName}}</Checkbox>
              </div>
              <div class="vertical_space"></div>
              <div class="vertical_space"></div>
            </div>
          </div>
        </div>
        <div>
          <p><b>עדיפות</b></p>
          <select v-model="priority" dir="rtl">
            <option value="10">עדיפות גבוהה</option>
            <option value="5">עדיפות בינונית</option>
            <option value="2">עדיפות נמוכה</option>
          </select>
        </div>
        <div v-if='false' class="pb-4">
          <p><b>לפרסם ב:</b></p>
          <div class="is-flex is-align-items-center">
            <div class="mx-2" v-for="supplier in ['Jobmaster', 'Alljobs', 'Drushim','Jobnet']" :key="supplier">
              <Checkbox @input="togglePublishOutsource(supplier)" :checked="publish_outsources.includes(supplier)">{{ supplier }}</Checkbox>
            </div>
          </div>
        </div>
        <div class="modal_footer">
          <a
            @click="submit()"
            :class="{ 'is-loading': is_submitting }"
            class="button is-info"
            >Submit</a
          >
        </div>
      </div>
      <div>
        <p v-if="payload.shuffle_position_id">SHUFFLE POSITION ID: <b>{{ payload.shuffle_position_id }}</b></p>
        <p v-if="payload.position_applicant_code">POSITION APPLICANT CODE: <b>{{ payload.position_applicant_code }}</b></p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import TextsHelper from '@/custom/classes/texts_helper.js'
import Checkbox from '@/components/Checkbox'
import OutsourceAllJobsCities from '@/components/OutsourceAllJobsCities'
import OutsourceJobMasterCities from '@/components/OutsourceJobMasterCities'
import OutsourceDrushimCities from '@/components/OutsourceDrushimCities'
import OutsourceDrushimAreas from '@/components/OutsourceDrushimAreas'
import OutsourceJobnetAreas from '@/components/OutsourceJobnetAreas'

export default {
  name: 'outsource-form',
  components: {
    Checkbox,
    OutsourceAllJobsCities,
    OutsourceJobMasterCities,
    OutsourceDrushimCities,
    OutsourceDrushimAreas,
    OutsourceJobnetAreas
  },
  props: ['payload'],
  data () {
    return {
      env: this.$settings.get({ path: 'operation_name' }),
      texts_helper: new TextsHelper(),
      isCreate: false,
      default_location: '',
      status: 'active',
      title: '',
      drushim_title: '',
      description: '',
      requirements: '',
      priority: '10',
      drushimActive: false,
      jobnetActive: true,
      is_boosting: false,
      is_submitting: false,
      is_loading: true,
      publish_outsources: ['Alljobs', 'Jobmaster', 'Jobnet'],
      alljobs_cities: [],
      alljobs_picked_cities: [],
      alljobs_job_types: [],
      jobmaster_picked_cities: [],
      drushim_init_data: {},
      drushim_zones_and_regions: [],
      drushim_picked_cities: [],
      drushim_picked_areas: [{}],
      drushim_picked_seniority: '',
      jobmaster_required_experience_years: '',
      jobnet: {
        jobAreas: [],
        jobTypes: [],
        areas: [],
        types: []
      }
    }
  },
  created () {
    let requests = [
      this.getAllJobsCities(),
      this.getAllJobsFullData(),
      this.getJobMasterJobTypes()
    ]
    if (this.jobnetActive) {
      requests.push(this.getJobnetFullData())
    }
    if (this.drushimActive) {
      requests.push(this.getDrushimInitData())
      requests.push(this.getDrushimZonesAndRegions())
    }
    Promise.all(requests).then(() => {
      this.getOutsourcePosition()
    })
  },
  methods: {
    submit () {
      if (this.description.includes('\\')) {
        this.$utils.emit('show_toast', { text: 'אנא מחק/י את התו \\ מתיאור' })
        return
      }
      if (this.title.includes('\\') || this.drushim_title.includes('\\')) {
        this.$utils.emit('show_toast', { text: 'אנא מחק/י את התו \\ מהכותרת' })
        return
      }
      if (this.requirements.includes('\\')) {
        this.$utils.emit('show_toast', { text: 'אנא מחק/י את התו \\ מדרישות' })
        return
      }
      if (this.jobmaster_picked_cities.length == 0) {
        this.$utils.emit('show_toast', { text: 'אנא בחר/י עיר עבודה (2)' })
        return
      }
      let picked_job_types = this.alljobs_job_types.filter(job_type => job_type.is_selected)
      if (picked_job_types.length == 0) {
        this.$utils.emit('show_toast', { text: 'אנא בחר/י היקף משרה (1)' })
        return
      }
      if (this.alljobs_picked_cities.length == 0) {
        this.$utils.emit('show_toast', { text: 'אנא בחר/י עיר עבודה (1)' })
        return
      }
      if (this.title.length == 0) {
        this.$utils.emit('show_toast', { text: 'כותרת ריקה' })
        return
      }
      if (this.title.length > 60) {
        this.$utils.emit('show_toast', { text: 'כותרת עד 60 תויים' })
        return
      }
      if (this.title.length > 50 && this.drushim_title.length == 0) {
        this.$utils.emit('show_toast', { text: 'כותרת של דרושים ריקה' })
        return
      }
      if (this.title.length > 50 && this.drushim_title.length > 50) {
        this.$utils.emit('show_toast', { text: 'כותרת של דרושים עד 50 תויים' })
        return
      }
      if (this.description.length == 0) {
        this.$utils.emit('show_toast', { text: 'תיאור ריק' })
        return
      }
      if (this.requirements.length == 0) {
        this.$utils.emit('show_toast', { text: 'דרישות ריק' })
        return
      }
      if (this.jobmaster_required_experience_years.length == 0) {
        this.$utils.emit('show_toast', { text: 'אנא בחר/י שנות נסיון דרושות למשרה' })
        return
      }
      let jobmaster_picked_job_types = this.getSelectedJobMasterJobTypes()
      if (jobmaster_picked_job_types.length == 0) {
        this.$utils.emit('show_toast', { text: 'אנא בחר/י היקף משרה (2)' })
        return
      }
      if (this.jobnetActive) {
        if (!this.jobnet.areas.length) {
          this.$utils.emit('show_toast', { text: 'אנא בחר/י אזור (4)' })
          return
        }
      }
      let drushim_picked_job_types
      if (this.drushimActive) {
        drushim_picked_job_types = this.getSelectedDrushimJobTypes()
        if (drushim_picked_job_types.length == 0) {
          this.$utils.emit('show_toast', { text: 'אנא בחר/י היקף משרה (3)' })
          return
        }
        if (this.drushim_picked_areas[0].zone_id == undefined) {
          this.$utils.emit('show_toast', { text: 'אנא בחר/י אזור (3)' })
          return
        }
        if (this.drushim_picked_seniority.length == 0) {
          this.$utils.emit('show_toast', { text: 'אנא בחר/י שנות ותק (3)' })
          return
        }
      }
      picked_job_types.map(job_type => {
        delete job_type.is_selected
        return job_type
      })
      this.alljobs_picked_cities.map(picked_city => {
        picked_city.JobStreets = []
        return picked_city
      })
      let request_data = {
        status: this.status,
        priority: this.priority,
        env: this.env,
        env_position_id: this.payload.env_position_id,
        title: this.title,
        drushim_title: this.title.length > 50 ? this.drushim_title : this.title,
        description: this.description,
        requirements: this.requirements,
        whatsapp_phone: '',
        publish_outsources: this.publish_outsources.join(','),
        jobmaster_cities: JSON.stringify(this.jobmaster_picked_cities),
        jobmaster_job_types: JSON.stringify(jobmaster_picked_job_types),
        alljobs_cities: JSON.stringify(this.alljobs_picked_cities),
        alljobs_job_types: JSON.stringify(picked_job_types),
        position_applicant_code: this.$utils.getPositionApplicantCode(this.payload.env_position_id),
        jobmaster_required_experience_years: this.jobmaster_required_experience_years
      }
      if (this.jobnetActive) {
        request_data.jobnet_areas = JSON.stringify(this.jobnet.areas)
        request_data.jobnet_job_types = JSON.stringify(this.picked_job_types)
      }
      if (this.drushimActive) {
        request_data.drushim_job_types = JSON.stringify(drushim_picked_job_types)
        request_data.drushim_cities = JSON.stringify(this.drushim_picked_cities)
        request_data.drushim_areas = JSON.stringify(this.drushim_picked_areas.filter(area => area.zone_id != undefined))
        request_data.drushim_seniority = this.drushim_picked_seniority
      }
      this.is_submitting = true
      let request_name = this.isCreate ? 'createOutsourcePosition' : 'updateOutsourcePosition'
      this.$network_utils[request_name](request_data).then(() => {
        this.is_submitting = false
        this.$utils.emit('show_toast', { text: 'משרת חוץ עודכנה בהצלחה' })
        this.remove(this.payload)
      }).catch(() => {
        this.is_submitting = false
        this.$utils.emit('show_toast', { text: 'ארעה שגיאה' })
      })
    },
    togglePublishOutsource (outsource) {
      if (this.publish_outsources.includes(outsource)) {
        this.publish_outsources = this.publish_outsources.filter(publish_outsource => publish_outsource != outsource)
        return
      }
      this.publish_outsources.push(outsource)
    },
    getOutsourcePosition () {
      this.$network_utils.getOutsourcePosition({ env: this.env, env_position_id: this.payload.env_position_id }).then(response => {
        if (response == null) {
          this.isCreate = true
          this.injectDefaultData()
          return
        }
        this.injectExistingPositionData(response)
      })
    },
    injectDefaultData () {
      let position_request = this.$network_utils.getPosition({ id: this.payload.env_position_id })
      let position_texts_request = this.$network_utils.getResourceTexts({ current_type: 'Position', current_resource_id: this.payload.env_position_id })
      this.$network_utils.caller.axios.all([position_request, position_texts_request]).then(response => {
        let position = response[0]
        let texts = response[1]
        let work_entails = this.texts_helper.getTextByDesignator(texts, 'work_entails')
        this.title = position.title
        this.description = this.texts_helper.getContent(work_entails).replace(/@@@/g, '\n')
        this.$network_utils.getInheritanceLocation({ position_id: this.payload.env_position_id, company_id: position.company.resource_id }).then(response => {
          this.default_location = (response != undefined && response[0] != undefined) ? response[0].description : ''
          this.is_loading = false
        })
      })
    },
    injectExistingPositionData (position) {
      this.publish_outsources = (position.publish_outsources == undefined || position.publish_outsources.length == 0) ? [] : position.publish_outsources.split(',')
      this.status = position.status
      this.priority = position.priority
      this.title = position.title
      this.drushim_title = position.drushim_title == undefined ? '' : position.drushim_title
      this.description = position.description
      this.requirements = position.requirements
      this.jobmaster_required_experience_years = position.jobmaster_required_experience_years || ''
      if (this.drushimActive) {
        this.drushim_picked_cities = position.drushim_cities == undefined ? [] : JSON.parse(position.drushim_cities)
        this.drushim_picked_areas = position.drushim_areas == undefined || position.drushim_areas == '[]' ? [{}] : JSON.parse(position.drushim_areas)
        this.drushim_picked_seniority = position.drushim_seniority || ''
      }
      if (this.jobnetActive) {
        this.jobnet.areas = position.jobnet_areas == undefined ? [] : JSON.parse(position.jobnet_areas)
        this.jobnet.types = position.jobnet_job_types == undefined ? [] : JSON.parse(position.jobnet_job_types)
      }
      this.jobmaster_picked_cities = position.jobmaster_cities == undefined ? [] : JSON.parse(position.jobmaster_cities)
      this.alljobs_picked_cities = position.alljobs_cities == undefined ? [] : JSON.parse(position.alljobs_cities)
      let alljobs_picked_job_types_ids = position.alljobs_job_types == undefined ? [] : JSON.parse(position.alljobs_job_types).map(job_type => job_type.JobTypeID)
      this.alljobs_job_types.map(job_type => {
        if (alljobs_picked_job_types_ids.includes(job_type.JobTypeID)) {
          job_type.is_selected = true
        }
        return job_type
      })
      this.is_loading = false
    },
    // Get data for dropdown options
    async fetchData (url, field) {
      try {
        const response = await this.$network_utils.caller.request('get', url, 'admin_headers')
        return field ? response[field] : response
      } catch (error) {
        console.error('An error occurred:', error)
      }
    },
    async getDrushimInitData () {
      this.drushim_init_data = await this.fetchData('/outsource_data/get_drushim_init_data')
    },
    async getDrushimZonesAndRegions () {
      this.drushim_zones_and_regions = await this.fetchData('/outsource_data/get_drushim_zones_and_regions')
    },
    async getAllJobsCities () {
      this.alljobs_cities = await this.fetchData('/outsource_data/get_alljobs_cities', 'Cities')
    },
    async getJobMasterJobTypes () {
      this.jobmaster_job_types = await this.fetchData('/outsource_data/get_jobmaster_job_types', 'jobTypeList')
    },
    async getAllJobsFullData () {
      const jobData = await this.fetchData('/outsource_data/get_alljobs_full_data', 'JobData')
      this.alljobs_job_types = jobData.JobTypes.filter(jobType => ['משרה מלאה', 'משרה חלקית', 'משמרות', 'פרילנס'].includes(jobType.JobTypeName))
    },
    async getJobnetFullData () {
      // const jobData = await this.fetchData('/outsource_data/get_jobnet_full_data', 'JobData')
      // Hard-coded data to replace server call temporarily
      const jobData = {
        'jobAreas': [
          {
            'text': 'צפון',
            'value': 'North'
          },
          {
            'text': 'שרון',
            'value': 'Sharon'
          },
          {
            'text': 'מרכז',
            'value': 'Center'
          },
          {
            'text': 'ירושלים',
            'value': 'Jerusalem'
          },
          {
            'text': 'שפלה',
            'value': 'Lowlands'
          },
          {
            'text': 'דרום',
            'value': 'South'
          },
          {
            'text': 'אילת',
            'value': 'Eilat'
          },
          {
            'text': 'חו"ל',
            'value': 'Abroad'
          }
        ]
      }
      this.jobnet.jobAreas = jobData.jobAreas
      this.jobnet.jobTypes = jobData.jobTypes || []
    },
    getSelectedJobMasterJobTypes () {
      const selectedJobTypes = this.alljobs_job_types.filter(({ is_selected }) => is_selected)
      return this.jobmaster_job_types.filter(({ jobtype }) => {
        let jobTypeName = jobtype == 'משרה חלקית' ? 'חלקית' : jobtype
        return selectedJobTypes.some(selectedJobType => jobTypeName == selectedJobType.JobTypeName)
      })
    },
    getSelectedDrushimJobTypes () {
      let alljobs_picked_job_types = this.alljobs_job_types.filter(job_type => job_type.is_selected)
      let selected_job_types = []
      for (let i = 0; i < this.drushim_init_data.job_types.length; i++) {
        let drushim_job_type = this.drushim_init_data.job_types[i]
        drushim_job_type.is_selected = false
        for (let j = 0; j < alljobs_picked_job_types.length; j++) {
          let alljobs_picked_job_type = alljobs_picked_job_types[j]
          if (alljobs_picked_job_type.JobTypeName == drushim_job_type.name) {
            drushim_job_type.is_selected = true
          }
          if (alljobs_picked_job_type.JobTypeName == 'פרילנס' && drushim_job_type.name == 'משרה זמנית') {
            drushim_job_type.is_selected = true
          }
        }
        selected_job_types.push(drushim_job_type)
      }
      return selected_job_types
    },
    async boost () {
      if (confirm('Are you sure you want to boost?')) {
        this.is_boosting = true
        try {
          await this.$network_utils.boostOutsourcePosition({ env: this.env, env_position_id: this.payload.env_position_id })
          this.$utils.emit('show_toast', { text: 'Boosted' })
        } catch {
          this.$utils.emit('show_toast', { text: 'שגיאה' })
        }
        this.is_boosting = false
      }
    },
    ...mapMutations('modals', ['remove'])
  }
}
</script>
<style scoped>
  .title_length{
    margin-top: 0;
    font-size: 12px;
  }
  .pick_category_container{
    cursor: pointer;
    background: url('/black_down_arrow.svg') no-repeat;
    background-position-y: center;
    background-position-x: 10px;
    background-size: 15px;
    width: 310px;
    display: inline-block;
    padding: 10px;
    border: 1px solid rgba(0, 0, 0, 0.1);
  }
</style>
